import React, { FC } from 'react';
import loadable from '@wix/yoshi-flow-editor/loadable';
import type { WidgetProps } from '@wix/yoshi-flow-editor';
import Widget from './Widget';
import type { ControllerProps } from './Widget';

const LoadableWidget = loadable(() => {
  return import(/* webpackChunkName: "Widget" */ './Widget');
});

const Root: FC<
  WidgetProps<
    ControllerProps & {
      useLoadable?: boolean;
    }
  >
> = ({ useLoadable, ...props }) => {
  if (useLoadable) {
    return <LoadableWidget {...props} />;
  } else {
    return <Widget {...props} />;
  }
};

export default Root;
